import { map } from "scripts/map/map";
import { Marker } from "./marker";
import { Sector } from "./sector";

export class Detector {
    id: string;
    name: string | null = null;
    public lat: number | null;
    public lng: number | null;
    public distance: number | null;
    public azimuth: number | null = null;
    public coneWidth: number | null;

    public startAngle: number | null = null;
    public endAngle: number | null = null;
    public stepRay: number | null = null;
    public criticalValue: number | null = null;

    public marker: Marker | null = null;
    public sector: Sector | null = null;

    public isVisible: boolean = true;
    private isActive: boolean = false;

    constructor(
        id: string,
        lat: number,
        lng: number,
        distance: number,
        coneWidth: number,
        isActive: boolean = false,
        sectorData?: any
    ){
        this.id = id;
        this.lat = lat;
        this.lng = lng;
        this.distance = distance;
        this.coneWidth = coneWidth;
        this.isActive = isActive;
        if (sectorData) {
            this.name = sectorData.name;
            this.azimuth = sectorData.azimuth;
            this.startAngle = sectorData.startAngle;
            this.endAngle = sectorData.endAngle;
            this.stepRay = sectorData.stepRay;
            this.criticalValue = sectorData.criticalValue;
        }
    }

    public setLatLng(lat: number, lng: number){
        this.lat = lat;
        this.lng = lng;
        if (this.marker){
            this.marker.lat = lat;
            this.marker.lng = lng;
            this.marker?.redraw();
        }
        if(this.sector){
            this.sector.lat = lat;
            this.sector.lng = lng;
            this.sector?.redraw();
        }
    }

    public drawMarker(){
    if(!this.lat || !this.lng) return;
    
    console.log('drawMarker вызван для:', this.name);
    console.log('Данные для маркера:', {
        name: this.name,
        azimuth: this.azimuth,
        distance: this.distance,
        angle: this.coneWidth
    });

    const markerData = {
        name: this.name,
        azimuth: this.azimuth,
        distance: this.distance,
        angle: this.coneWidth
    };
    
    this.marker = new Marker(this.lat, this.lng, markerData, this.isActive);
    this.marker.draw();
}
    public drawSector() {
        if(!this.azimuth || !this.lat || !this.lng || !this.distance || !this.coneWidth) return;
        this.sector = new Sector(this.id, this.lat, this.lng, this.distance, this.azimuth, this.coneWidth);
        this.sector?.draw();
    }

    public reset() {
        this.marker?.remove();
        this.marker = null;
        this.sector?.remove();
        this.sector = null;

        this.lat = null;
        this.lng = null;
        this.distance = null;
        this.coneWidth = null;
        this.azimuth = null;
    }

    public setAzimuth(endLat: number, endLng: number) {
        if(!this.lat || !this.lng) return;
        this.azimuth = this.calculateBearing(endLat, endLng);

        if(this.sector && this.azimuth){
            this.sector.azimuth = this.azimuth;
            this.sector.redraw();
        }
    }

    public setCone(value: number) {
        
        this.coneWidth = value;
        
        if(!this.sector) return;
        
        this.sector.coneWidth = value;
        this.sector.redraw()
    }

    /**
     * Удаляем маркер и сектор 
     */
    public removeGraphics() {
        this.marker?.remove();
        this.sector?.remove();
        this.marker = null;
        this.sector = null;
    }

    /**
     * Центрируем камеру на датчик
     */
    public setCenterScreen() {
        if(!this.lng || !this.lat) return;

        map.flyTo({
            center: [this.lng, this.lat],
            zoom: 14
        });
    }


    private calculateBearing(endLat: number, endLng: number) {
        if(!this.lat || !this.lng) return null;
        const startLat = this.lat * Math.PI / 180;
        const startLng = this.lng * Math.PI / 180;
        const endLatCalc = endLat * Math.PI / 180;
        const endLngCalc = endLng * Math.PI / 180;
    
        const dLng = endLngCalc - startLng;
    
        const y = Math.sin(dLng) * Math.cos(endLatCalc);
        const x =
            Math.cos(startLat) * Math.sin(endLatCalc) -
            Math.sin(startLat) * Math.cos(endLatCalc) * Math.cos(dLng);
    
        return (Math.atan2(y, x) * 180 / Math.PI + 360) % 360;
    }

    public clone(){
        if (!this.lat || !this.lng || !this.distance || !this.coneWidth) return null;
        const cloneDetector = new Detector(this.id, this.lat, this.lng, this.distance, this.coneWidth, false);
        cloneDetector.azimuth = this.azimuth;
        cloneDetector.name = this.name;
        cloneDetector.startAngle = this.startAngle;
        cloneDetector.endAngle = this.endAngle;
        cloneDetector.stepRay = this.stepRay;
        cloneDetector.criticalValue = this.criticalValue;
        return cloneDetector;
    }

    public setVisible(visible: boolean) {
    this.isVisible = visible;
    
    if (visible) {
        // Показываем - пересоздаём маркер и сектор заново с сохранёнными данными
        
        // Сохраняем данные перед пересозданием
        const savedLat = this.lat;
        const savedLng = this.lng;
        const savedAzimuth = this.azimuth;
        const savedDistance = this.distance;
        const savedConeWidth = this.coneWidth;
        const savedName = this.name;
        
        if (savedLat && savedLng) {
            // Удаляем старые, если есть
            if (this.marker) {
                this.marker.remove();
                this.marker = null;
            }
            // Создаём новый маркер
            const markerData = {
                name: savedName,
                azimuth: savedAzimuth,
                distance: savedDistance,
                angle: savedConeWidth
            };
            this.marker = new Marker(savedLat, savedLng, markerData, this.isActive);
            this.marker.draw();
        }
        
        if (savedAzimuth && savedLat && savedLng && savedDistance && savedConeWidth) {
            // Удаляем старый сектор, если есть
            if (this.sector) {
                this.sector.remove();
                this.sector = null;
            }
            // Создаём новый сектор
            this.sector = new Sector(this.id, savedLat, savedLng, savedDistance, savedAzimuth, savedConeWidth);
            this.sector.draw();
        }
    } else {
        // Скрываем - удаляем и очищаем
        if (this.marker) {
            this.marker.remove();
            this.marker = null;
        }
        if (this.sector) {
            this.sector.remove();
            this.sector = null;
        }
    }
}

    public getVisible(): boolean {
        return this.isVisible;
    }

}



